import { CalendarDays, MapPin, Store, Timer } from 'lucide-react';

const IMC_START = new Date('2026-10-07T00:00:00+05:30');
const IMC_END = new Date('2026-10-11T00:00:00+05:30');

const countdownLabel = () => {
  const now = Date.now();
  if (now >= IMC_END.getTime()) return null;
  if (now >= IMC_START.getTime()) return 'Happening now';
  const days = Math.ceil((IMC_START.getTime() - now) / 86400000);
  return days === 1 ? '1 day to go' : `${days} days to go`;
};

export const ImcPromoSlide = () => {
  const countdown = countdownLabel();
  return (
  <div
    data-testid="imc-promo-slide"
    className="relative w-full h-full overflow-hidden bg-[var(--mm-purple-dark)]"
  >
    <div
      className="absolute inset-0 opacity-90"
      style={{ background: 'radial-gradient(120% 120% at 15% 10%, #6B1B80 0%, #2E0838 55%, #1A0F24 100%)' }}
      aria-hidden="true"
    />
    <div
      className="absolute -right-24 -bottom-28 w-[460px] h-[460px] rounded-full opacity-25"
      style={{ background: 'radial-gradient(circle, #A62B99 0%, transparent 70%)' }}
      aria-hidden="true"
    />

    <div className="relative h-full max-w-6xl mx-auto px-6 md:px-10 flex flex-col justify-center gap-4 md:gap-6">
      <div className="flex items-center gap-4 md:gap-6">
        <img src="/mashmari-logo.png" alt="Mashmari" className="h-7 md:h-10 w-auto brightness-0 invert" />
        <span className="h-7 md:h-9 w-px bg-white/25" aria-hidden="true" />
        <img src="/imc/imc10logo.png" alt="India Mobile Congress 2026" className="h-9 md:h-14 w-auto" />
      </div>

      <div>
        <p className="text-[10px] md:text-[11px] font-bold tracking-[0.22em] uppercase text-[#00E599]">
          #IMC2026 · Meet us there
        </p>
        {countdown && (
          <p
            data-testid="imc-countdown"
            className="mt-2 inline-flex items-center gap-2 text-[11px] md:text-sm font-bold text-[#1A0F24] bg-[#00E599] rounded-full px-3 py-1"
          >
            <Timer className="w-3.5 h-3.5 md:w-4 md:h-4" /> {countdown}
          </p>
        )}
        <h2 className="mt-2 text-xl sm:text-3xl md:text-4xl font-bold text-white leading-[1.12] max-w-2xl">
          Meet Mashmari at <span className="text-[#F0A6E4]">India Mobile Congress 2026</span>
        </h2>
        <p className="mt-2 md:mt-3 text-sm md:text-base text-white/70 max-w-xl leading-relaxed hidden sm:block">
          Classroom execution, Digital Anganwadi, Secure MDM and NetRakshak — live, end to end.
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2.5 md:gap-3 text-[11px] md:text-sm text-white/85">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5">
          <CalendarDays className="w-3.5 h-3.5 md:w-4 md:h-4" /> 7–10 October 2026
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5">
          <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4" /> Yashobhoomi, New Delhi
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-[#00E599]/15 border border-[#00E599]/35 text-[#8DF6CC] px-3 py-1.5">
          <Store className="w-3.5 h-3.5 md:w-4 md:h-4" /> Booth AI.B1 · MSME Pavilion
        </span>
      </div>
    </div>
  </div>
  );
};

export default ImcPromoSlide;
